import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getLeads } from '../api/leads';
import type { GetLeadsParams, LeadListItem, PagedResult } from '../types';

export function useLeads(
  params: GetLeadsParams = {},
  options?: Pick<UseQueryOptions<PagedResult<LeadListItem>>, 'enabled'>,
) {
  return useQuery({
    queryKey: ['leads', params],
    queryFn: () => getLeads(params),
    ...listQueryDefaults,
    ...options,
  });
}
